/* =========================================================
   ADHÉSIF-VITRAIL — VISUALISEUR 2
   FICHES PRODUITS CLASSIQUES SHOPIFY DAWN

   - Modèle vitrail récupéré automatiquement depuis Shopify
   - Une seule zone de vitrage avec 4 points ajustables
   - Import de la photo de pièce uniquement
   - Contrôle de compatibilité des orientations
   - Projection adaptative avec perspective
   - Simulation affichée directement dans la scène

   Module indépendant du Visualiseur 1
   Aucun configurateur, BAT ou fichier de production
   ========================================================= */

    /* =========================================================
      ÉLÉMENTS
    ========================================================= */

    const photoPiece = document.getElementById("photoPiece");
    const importPhoto = document.getElementById("importPhoto");
    const zonePhoto = document.getElementById("zonePhoto");
    const scene = document.getElementById("scene");
    const photo = document.getElementById("apercuPhoto");
    const messagePhoto = document.getElementById("messagePhoto");

    const surfaceVitree = document.getElementById("surfaceVitree");
    const contourVitree = document.getElementById("contourVitree");
    const calqueSelection2 = document.getElementById("calqueSelection2");
    const surfaceVitree2 = document.getElementById("surfaceVitree2");
    const contourVitree2 = document.getElementById("contourVitree2");

    const aideSelection = document.getElementById("aideSelection");
    const validationZone = document.getElementById("validationZone");
    const boutonValiderZone = document.getElementById("boutonValiderZone");
    const zoneValidee = document.getElementById("zoneValidee");
    const boutonModifierZone = document.getElementById("boutonModifierZone");

    const ajoutZone2 = document.getElementById("ajoutZone2");
    const boutonAjouterZone2 = document.getElementById("boutonAjouterZone2");
    const validationZone2 = document.getElementById("validationZone2");
    const aideSelection2 = document.getElementById("aideSelection2");
    const boutonValiderZone2 = document.getElementById("boutonValiderZone2");
    const zoneValidee2 = document.getElementById("zoneValidee2");
    const boutonModifierZone2 = document.getElementById("boutonModifierZone2");
    const boutonSupprimerZone2 = document.getElementById("boutonSupprimerZone2");

    const zoneInferieure = document.getElementById("zoneInferieure");
    const visuelAdhesif = document.getElementById("visuelAdhesif");
    const apercuAdhesif = document.getElementById("apercuAdhesif");
    const apercuAdhesifBloc = document.getElementById("apercuAdhesifBloc");
    const boutonSupprimerVisuel = document.getElementById("boutonSupprimerVisuel");

    const carteVisuelZone2 = document.getElementById("carteVisuelZone2");
    const memeVisuelZone2 = document.getElementById("memeVisuelZone2");
    const autreVisuelZone2 = document.getElementById("autreVisuelZone2");
    const importVisuelZone2 = document.getElementById("importVisuelZone2");
    const visuelAdhesif2 = document.getElementById("visuelAdhesif2");
    const apercuAdhesif2 = document.getElementById("apercuAdhesif2");
    const apercuAdhesifBloc2 = document.getElementById("apercuAdhesifBloc2");
    const boutonSupprimerVisuel2 = document.getElementById("boutonSupprimerVisuel2");

    const boutonReinitialiser = document.getElementById("boutonReinitialiser");
    const actionsPrincipales = document.getElementById("actionsPrincipales");
    const boutonVisualiser = document.getElementById("boutonVisualiser");
    const messageEtat = document.getElementById("messageEtat");
    const canvasResultat = document.getElementById("canvasResultat");

    const actionsPhoto = document.getElementById("actionsPhoto");
    const actionsResultatScene = document.getElementById("actionsResultatScene");
    const badgeSimulation = document.getElementById("badgeSimulation");
    const boutonModifierSimulation = document.getElementById("boutonModifierSimulation");
    const boutonNouvelleSimulation = document.getElementById("boutonNouvelleSimulation");
    const noteSimulation = document.getElementById("noteSimulation");

    const warningOrientation = document.getElementById("warningOrientation");
    const warningOrientationTexte = document.getElementById("warningOrientationTexte");
    const warningChangerVisuel = document.getElementById("warningChangerVisuel");
    const warningModifierZone = document.getElementById("warningModifierZone");

    const etape1 = document.getElementById("etape1");
    const etape2 = document.getElementById("etape2");
    const etape3 = document.getElementById("etape3");

    const poignees = [
      document.getElementById("point0"),
      document.getElementById("point1"),
      document.getElementById("point2"),
      document.getElementById("point3")
    ];

    const poignees2 = [
      document.getElementById("point2_0"),
      document.getElementById("point2_1"),
      document.getElementById("point2_2"),
      document.getElementById("point2_3")
    ];

    /* =========================================================
      ÉTAT
    ========================================================= */

    let points = [];
    let pointsNormalises = [];
    let pointActif = null;
    let zoneVerrouillee = false;

    let zone2Active = false;
    let points2 = [];
    let pointsNormalises2 = [];
    let pointActif2 = null;
    let zone2Verrouillee = false;

    let modeResultat = false;

    let fichierPhotoPiece = null;
    let fichierVisuelAdhesif = null;
    let fichierVisuelAdhesif2 = null;

    let urlPhotoPiece = null;
    let urlVisuelAdhesif = null;
    let urlVisuelAdhesif2 = null;

    let controleOrientationActuel = null;
    let controleOrientationZone2 = null;
    let verificationOrientationEnCours = false;
    let warningZoneActuelle = 1;

    /* =========================================================
      LIAISON CONFIGURATEUR → VISUALISEUR
    ========================================================= */

    const AV_VISUALISEUR_BACKEND_URL = "https://api.adhesif-vitrail.com";
    const AV_VISUALISEUR_HEARTBEAT_INTERVAL_MS = 10 * 60 * 1000;
    const AV_VISUALISEUR_HEARTBEAT_MIN_GAP_MS = 5 * 1000;

    const parametresVisualiseur =
      new URLSearchParams(
        window.location.search
      );


const modeVisualiseur = "modele";


    let assetIdConfigurateur = null;

let jetonPriveVisualiseur = null;



    /*
    * =========================================================
    * INTÉGRATION SHOPIFY
    * =========================================================
    *
    * Le visualiseur est maintenant intégré directement
    * dans la même page que le configurateur.
    *
    * Il ne récupère donc plus l'assetId dans l'URL.
    * Le configurateur lui transmet l'UUID du fichier
    * préparé via l'événement "av:visualizer-ready".
    */

    window.addEventListener(
      "av:visualizer-ready",
      async event => {
            // Visualiseur 2 : ignorer les événements du configurateur.
    if (modeVisualiseur === "modele") return;

        
const assetId =
  event.detail?.assetId || null;

const jetonRecu =
  event.detail?.jetonPrive || null;

jetonPriveVisualiseur =
  typeof jetonRecu === "string" &&
  /^[a-f0-9]{64}$/i.test(jetonRecu)
    ? jetonRecu
    : null;


        if (!assetId) {
      assetIdConfigurateur = null;

      visuelPrincipalDepuisConfigurateur = false;
      metadonneesVisuelPrincipal = null;
      fichierVisuelAdhesif = null;
      urlVisuelAdhesif = null;

      if (heartbeatVisualiseurTimer) {
        clearInterval(heartbeatVisualiseurTimer);
        heartbeatVisualiseurTimer = null;
      }

      if (existe(apercuAdhesif)) {
        apercuAdhesif.removeAttribute("src");
      }

      masquer(apercuAdhesifBloc);

      invaliderControlesOrientation();
      mettreAJourInterface();

      return;
    }

        /*
        * Si le même fichier est déjà chargé,
        * inutile de le redemander au backend.
        */
        if (
          assetIdConfigurateur === assetId &&
          visuelPrincipalDepuisConfigurateur
        ) {
          return;
        }

        assetIdConfigurateur = assetId;

        try {
          await chargerVisuelPrincipalDepuisConfigurateur();

          document
            .getElementById("avVisualiseurIntegre")
            ?.classList.add(
              "av-visualiseur-fichier-pret"
            );
        }

        catch (erreur) {
          console.error(
            "[Adhésif-Vitrail] Impossible de transmettre le visuel au visualiseur :",
            erreur
          );
        }
      }
    );

    let visuelPrincipalDepuisConfigurateur =
      false;

    let metadonneesVisuelPrincipal =
      null;

    let heartbeatVisualiseurTimer =
      null;

    let heartbeatVisualiseurEnCours =
      false;

    let dernierHeartbeatVisualiseurAt =
      0;

    /* =========================================================
      RÉGLAGES — CONSERVÉS DE LA V4
    ========================================================= */

    const OPACITE_ADHESIF = 0.72;
    const SUBDIVISIONS = 30;

    const SEUIL_VERTICAL = 0.80;
    const SEUIL_HORIZONTAL = 1.25;

    const TOLERANCE_LIBRE = 0.055;
    const DEFORMATION_MAX = 0.085;

    const POSITION_CADRAGE_X = 0.5;
    const POSITION_CADRAGE_Y = 0.5;

    /* =========================================================
      OUTILS
    ========================================================= */

    function existe(element) {
      return element !== null && element !== undefined;
    }

    function afficher(element, display = "block") {
      if (existe(element)) element.style.display = display;
    }

    function masquer(element) {
      if (existe(element)) element.style.display = "none";
    }

    function creerURL(fichier, ancienneURL) {
      /*
      * On ne révoque que les URL blob créées localement.
      * Une URL HTTP provenant du backend ne doit jamais
      * être passée à URL.revokeObjectURL().
      */
      if (
        typeof ancienneURL === "string" &&
        ancienneURL.startsWith("blob:")
      ) {
        URL.revokeObjectURL(
          ancienneURL
        );
      }

      return URL.createObjectURL(
        fichier
      );
    }

    
function chargerImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    // Autorise le chargement des images Shopify CDN
    // pour leur utilisation dans le canvas.
    if (
      typeof url === "string" &&
      /^https?:\/\//i.test(url)
    ) {
      image.crossOrigin = "anonymous";
    }

    image.onload = () => resolve(image);

    image.onerror = () =>
      reject(new Error("Impossible de charger l'image."));

    image.src = url;
  });
}


    function obtenirModeVisuelZone2() {
      return autreVisuelZone2 && autreVisuelZone2.checked
        ? "autre"
        : "meme";
    }

    function obtenirFichierZone2() {
      return obtenirModeVisuelZone2() === "autre"
        ? fichierVisuelAdhesif2
        : fichierVisuelAdhesif;
    }

    function obtenirURLZone2() {
      return obtenirModeVisuelZone2() === "autre"
        ? urlVisuelAdhesif2
        : urlVisuelAdhesif;
    }

    function zone2Prete() {
      if (!zone2Active) {
        return true;
      }

      if (
        !zone2Verrouillee ||
        pointsNormalises2.length !== 4
      ) {
        return false;
      }

      return Boolean(obtenirFichierZone2());
    }

    function invaliderControlesOrientation() {
      controleOrientationActuel = null;
      controleOrientationZone2 = null;
      masquerWarningOrientation();
    }
    /* =========================================================
      BACKEND — VISUEL PRINCIPAL PARTAGÉ
    ========================================================= */

    async function lireErreurBackend(reponse) {
      try {
        const data =
          await reponse.json();

        return (
          data.error ||
          data.message ||
          `Erreur ${reponse.status}`
        );
      }
      catch (erreur) {
        return `Erreur ${reponse.status}`;
      }
    }

    function construireURLBackend(chemin) {
      return new URL(
        chemin,
        `${AV_VISUALISEUR_BACKEND_URL}/`
      ).toString();
    }

    function obtenirURLVisuelDepuisMetadonnees(
      metadata
    ) {
      const final =
        metadata?.fichiers?.final;

      const normalise =
        metadata?.fichiers?.normalise;

      /*
      * Priorité absolue au FINAL lorsqu'un cadrage
      * a été validé dans le configurateur.
      *
      * S'il n'y avait aucun cadrage à effectuer,
      * le NORMALISÉ devient le visuel de référence.
      */
      if (final?.nomStocke) {
        return construireURLBackend(
          `storage/production/${encodeURIComponent(
            final.nomStocke
          )}`
        );
      }

      if (normalise?.nomStocke) {
        return construireURLBackend(
          `storage/normalises/${encodeURIComponent(
            normalise.nomStocke
          )}`
        );
      }

      return null;
    }

    async function envoyerHeartbeatVisualiseur(
      force = false
    ) {
      if (
        !assetIdConfigurateur ||
        document.visibilityState !== "visible"
      ) {
        return;
      }

      if (heartbeatVisualiseurEnCours) {
        return;
      }

      const maintenant =
        Date.now();

      if (
        !force &&
        maintenant -
          dernierHeartbeatVisualiseurAt <
          AV_VISUALISEUR_HEARTBEAT_MIN_GAP_MS
      ) {
        return;
      }

      heartbeatVisualiseurEnCours =
        true;

      dernierHeartbeatVisualiseurAt =
        maintenant;

      try {
        const reponse =
          await fetch(
            `${AV_VISUALISEUR_BACKEND_URL}/api/production/activity`,
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body: JSON.stringify({
                id: assetIdConfigurateur
              })
            }
          );

        if (!reponse.ok) {
          throw new Error(
            await lireErreurBackend(
              reponse
            )
          );
        }
      }
      catch (erreur) {
        console.warn(
          "[Adhésif-Vitrail] Heartbeat visualiseur non envoyé :",
          erreur
        );
      }
      finally {
        heartbeatVisualiseurEnCours =
          false;
      }
    }

    function demarrerHeartbeatVisualiseur() {
      if (!assetIdConfigurateur) {
        return;
      }

      if (heartbeatVisualiseurTimer) {
        clearInterval(
          heartbeatVisualiseurTimer
        );
      }

      envoyerHeartbeatVisualiseur(true);

      heartbeatVisualiseurTimer =
        setInterval(
          () =>
            envoyerHeartbeatVisualiseur(
              false
            ),

          AV_VISUALISEUR_HEARTBEAT_INTERVAL_MS
        );
    }

    function masquerImportVisuelPrincipal() {
      if (!existe(visuelAdhesif)) {
        return;
      }

      /*
      * Le fichier appartient déjà au configurateur :
      * on interdit donc un second import du visuel 1.
      */
      visuelAdhesif.disabled = true;

      const label =
        document.querySelector(
          'label[for="visuelAdhesif"]'
        );

      if (label) {
        masquer(label);
      }

      masquer(
        boutonSupprimerVisuel
      );
    }

    async function chargerVisuelPrincipalDepuisConfigurateur() {
      if (!assetIdConfigurateur) {
        return false;
      }

      try {
        if (existe(messageEtat)) {
          messageEtat.textContent =
            "Chargement de votre visuel déjà préparé…";
        }

       
const reponse =
  await fetch(
    `${AV_VISUALISEUR_BACKEND_URL}/api/production/${encodeURIComponent(
      assetIdConfigurateur
    )}`,
    {
      method: "GET",
      headers: jetonPriveVisualiseur
        ? {
            "X-AV-Access-Token": jetonPriveVisualiseur
          }
        : {}
    }
  );


        if (!reponse.ok) {
          throw new Error(
            await lireErreurBackend(
              reponse
            )
          );
        }

        const donneesBackend =
      await reponse.json();

    const metadata =
      donneesBackend?.asset ||
      donneesBackend;

    const url =
      obtenirURLVisuelDepuisMetadonnees(
        metadata
      );

        if (!url) {
          throw new Error(
            "Aucun fichier FINAL ou normalisé n'est disponible."
          );
        }

        /*
        * Le moteur V5 vérifie fichierVisuelAdhesif.
        * On lui fournit donc une référence logique.
        * Le gros fichier n'est PAS dupliqué.
        */
        fichierVisuelAdhesif = {
          source: "backend",
          assetId:
            assetIdConfigurateur,

          nom:
            metadata?.nomClient ||
            "Visuel personnalisé"
        };

        urlVisuelAdhesif =
          url;

        metadonneesVisuelPrincipal =
          metadata;

        visuelPrincipalDepuisConfigurateur =
          true;

        invaliderControlesOrientation();

        masquerImportVisuelPrincipal();

        /*
        * On affiche directement le visuel reçu
        * du configurateur dans l'aperçu V5.
        */
        if (existe(apercuAdhesif)) {
          await new Promise(
            (resolve, reject) => {
              apercuAdhesif.onload =
                () => resolve();

              apercuAdhesif.onerror =
                () =>
                  reject(
                    new Error(
                      "Impossible de charger l'aperçu du visuel préparé."
                    )
                  );

              apercuAdhesif.src =
                urlVisuelAdhesif;
            }
          );

          afficher(
            apercuAdhesifBloc,
            "flex"
          );
        }

        demarrerHeartbeatVisualiseur();

        mettreAJourInterface();

        console.log(
          "[Adhésif-Vitrail] Visuel du configurateur chargé",
          {
            assetId:
              assetIdConfigurateur,

            source:
              metadata?.fichiers?.final
                ?.nomStocke
                ? "FINAL"
                : "NORMALISÉ",

            url:
              urlVisuelAdhesif
          }
        );

        return true;
      }
      catch (erreur) {
        console.error(
          "[Adhésif-Vitrail] Chargement visuel configurateur :",
          erreur
        );

        fichierVisuelAdhesif =
          null;

        urlVisuelAdhesif =
          null;

        visuelPrincipalDepuisConfigurateur =
          false;

        if (existe(messageEtat)) {
          messageEtat.textContent =
            "Votre visuel n'a pas pu être récupéré. Revenez au configurateur et réessayez.";
        }

        alert(
          "Le visuel préparé par le configurateur n'a pas pu être chargé. Vérifiez que le backend local est toujours démarré."
        );

        mettreAJourInterface();

        return false;
      }
    }
    /* =========================================================
      WARNING ORIENTATION
    ========================================================= */

    function nomOrientation(orientation) {
      if (orientation === "vertical") {
        return "vertical";
      }

      if (orientation === "horizontal") {
        return "horizontal";
      }

      return "adaptable";
    }

    function masquerWarningOrientation() {
      if (existe(warningOrientation)) {
        warningOrientation.classList.remove("est-visible");
      }
    }

    function afficherWarningOrientation(
      controle,
      numeroZone = 1
    ) {
      if (
        !existe(warningOrientation) ||
        !controle
      ) {
        return;
      }

      warningZoneActuelle = numeroZone;

      const vitrage =
        nomOrientation(
          controle.orientationVitrage
        );

      const visuel =
        nomOrientation(
          controle.orientationVisuel
        );

      const prefixe =
        zone2Active
          ? `La zone ${numeroZone}`
          : "La zone de vitrage sélectionnée";

      if (existe(warningOrientationTexte)) {
        warningOrientationTexte.innerHTML =
          `${prefixe} est au format <strong>${vitrage}</strong>, ` +
          `tandis que le visuel associé est au format <strong>${visuel}</strong>. ` +
          `Choisissez un visuel ${vitrage} ou modifiez cette zone ` +
          `pour obtenir une visualisation réaliste.`;
      }

      warningOrientation.classList.add(
        "est-visible"
      );
    }

    /* =========================================================
      MODES SÉLECTION / RÉSULTAT
    ========================================================= */

    function activerModeSelection() {
      modeResultat = false;

      if (existe(scene)) {
        scene.classList.remove(
          "mode-resultat"
        );
      }

      if (existe(canvasResultat)) {
        canvasResultat.style.display =
          "none";
      }

      masquer(actionsResultatScene);
      masquer(badgeSimulation);
      masquer(noteSimulation);

      if (fichierPhotoPiece) {
  afficher(apercuPhoto);
  afficher(validationZone);
  afficher(actionsPhoto, "flex");
}

      afficherSelectionsSelonEtat();
      mettreAJourInterface();
    }

    function activerModeResultat() {
      modeResultat = true;

      masquerWarningOrientation();

      if (existe(scene)) {
        scene.classList.add(
          "mode-resultat"
        );
      }

      if (existe(canvasResultat)) {
        canvasResultat.style.display =
          "block";
      }

      masquer(validationZone);
      masquer(actionsPhoto);

      masquerSelectionComplete();

      afficher(
        actionsResultatScene,
        "flex"
      );

      afficher(
        badgeSimulation,
        "flex"
      );

      afficher(
        noteSimulation,
        "flex"
      );

      if (existe(messageEtat)) {
        messageEtat.textContent =
          "Votre simulation est prête.";
      }

      etatEtape(
        etape1,
        true,
        false
      );

      etatEtape(
        etape2,
        true,
        false
      );

      etatEtape(
        etape3,
        true,
        false
      );
    }

    /* =========================================================
      IMPORT PHOTO
    ========================================================= */

    if (existe(photoPiece)) {
      photoPiece.addEventListener(
        "change",
        () => {
          const fichier =
            photoPiece.files[0];

          if (!fichier) {
            return;
          }

          if (
            !fichier.type.startsWith(
              "image/"
            )
          ) {
            alert(
              "Veuillez sélectionner une image."
            );

            photoPiece.value = "";

            return;
          }

          fichierPhotoPiece = fichier;

          urlPhotoPiece =
            creerURL(
              fichier,
              urlPhotoPiece
            );

          zoneVerrouillee = false;
          zone2Active = false;
          zone2Verrouillee = false;

          modeResultat = false;

          points = [];
          pointsNormalises = [];

          points2 = [];
          pointsNormalises2 = [];

          verificationOrientationEnCours =
            false;

          invaliderControlesOrientation();

          if (existe(scene)) {
            scene.classList.remove(
              "zone-verrouillee",
              "zone2-active"
            );
          }

          masquer(zoneValidee);
          masquer(zoneValidee2);
          masquer(validationZone2);
          masquer(ajoutZone2);
          masquer(carteVisuelZone2);
          masquer(calqueSelection2);

          poignees2.forEach(
            masquer
          );

          if (
            existe(
              boutonValiderZone
            )
          ) {
            boutonValiderZone.style.display =
              "inline-flex";
          }

          photo.onload = () => {
            masquer(importPhoto);
            masquer(messagePhoto);

            afficher(zonePhoto);

            afficher(
              scene,
              "inline-block"
            );

            afficher(aideSelection);
            afficher(validationZone);

            afficher(
              zoneInferieure,
              "grid"
            );

            afficher(
              actionsPrincipales
            );

            afficher(
              actionsPhoto,
              "flex"
            );

            requestAnimationFrame(
              () => {
                initialiserSelection();
                activerModeSelection();
              }
            );
          };

          photo.src =
            urlPhotoPiece;
        }
      );
    }

    /* =========================================================
      IMPORT VISUEL 1
    ========================================================= */

    if (existe(visuelAdhesif)) {
      visuelAdhesif.addEventListener(
        "change",
        () => {
          const fichier =
            visuelAdhesif.files[0];

          if (!fichier) {
            return;
          }

          if (
            !fichier.type.startsWith(
              "image/"
            )
          ) {
            alert(
              "Veuillez sélectionner une image."
            );

            visuelAdhesif.value = "";

            return;
          }

          fichierVisuelAdhesif =
            fichier;

          urlVisuelAdhesif =
            creerURL(
              fichier,
              urlVisuelAdhesif
            );

          invaliderControlesOrientation();

          apercuAdhesif.onload =
            async () => {
              afficher(
                apercuAdhesifBloc,
                "flex"
              );

              if (modeResultat) {
                activerModeSelection();
              }

              await verifierOrientationActuelle();

              mettreAJourInterface();
            };

          apercuAdhesif.src =
            urlVisuelAdhesif;

          afficher(
            apercuAdhesifBloc,
            "flex"
          );

          mettreAJourInterface();
        }
      );
    }

    /* =========================================================
      SUPPRIMER VISUEL 1
    ========================================================= */

    if (
      existe(
        boutonSupprimerVisuel
      )
    ) {
      boutonSupprimerVisuel.addEventListener(
        "click",
        () => {
                if (visuelPrincipalDepuisConfigurateur) {
            return;
          }
          fichierVisuelAdhesif =
            null;

          verificationOrientationEnCours =
            false;

          invaliderControlesOrientation();

          if (urlVisuelAdhesif) {
            URL.revokeObjectURL(
              urlVisuelAdhesif
            );

            urlVisuelAdhesif =
              null;
          }

          if (existe(visuelAdhesif)) {
            visuelAdhesif.value = "";
          }

          if (existe(apercuAdhesif)) {
            apercuAdhesif.removeAttribute(
              "src"
            );
          }

          masquer(
            apercuAdhesifBloc
          );

          activerModeSelection();

          mettreAJourInterface();
        }
      );
    }

    /* =========================================================
      IMPORT VISUEL 2
    ========================================================= */

    if (existe(visuelAdhesif2)) {
      visuelAdhesif2.addEventListener(
        "change",
        () => {
          const fichier =
            visuelAdhesif2.files[0];

          if (!fichier) {
            return;
          }

          if (
            !fichier.type.startsWith(
              "image/"
            )
          ) {
            alert(
              "Veuillez sélectionner une image."
            );

            visuelAdhesif2.value = "";

            return;
          }

          fichierVisuelAdhesif2 =
            fichier;

          urlVisuelAdhesif2 =
            creerURL(
              fichier,
              urlVisuelAdhesif2
            );

          controleOrientationZone2 =
            null;

          masquerWarningOrientation();

          apercuAdhesif2.onload =
            async () => {
              afficher(
                apercuAdhesifBloc2,
                "flex"
              );

              if (modeResultat) {
                activerModeSelection();
              }

              await verifierOrientationActuelle();

              mettreAJourInterface();
            };

          apercuAdhesif2.src =
            urlVisuelAdhesif2;

          afficher(
            apercuAdhesifBloc2,
            "flex"
          );

          mettreAJourInterface();
        }
      );
    }

    if (
      existe(
        boutonSupprimerVisuel2
      )
    ) {
      boutonSupprimerVisuel2.addEventListener(
        "click",
        () => {
          fichierVisuelAdhesif2 =
            null;

          controleOrientationZone2 =
            null;

          masquerWarningOrientation();

          if (urlVisuelAdhesif2) {
            URL.revokeObjectURL(
              urlVisuelAdhesif2
            );

            urlVisuelAdhesif2 =
              null;
          }

          if (existe(visuelAdhesif2)) {
            visuelAdhesif2.value = "";
          }

          if (existe(apercuAdhesif2)) {
            apercuAdhesif2.removeAttribute(
              "src"
            );
          }

          masquer(
            apercuAdhesifBloc2
          );

          if (modeResultat) {
            activerModeSelection();
          }

          mettreAJourInterface();
        }
      );
    }

    
  /* =========================================================
    FICHIER 2 — REMPLACEMENT DEPUIS LE CONFIGURATEUR
    ========================================================= */

  window.addEventListener(
    "av:remplacer-fichier-zone2",
    function () {
      if (
        !zone2Active ||
        obtenirModeVisuelZone2() !== "autre" ||
        !existe(visuelAdhesif2)
      ) {
        return;
      }

      // Réutilise la suppression déjà gérée par le visualiseur.
      if (existe(boutonSupprimerVisuel2)) {
        boutonSupprimerVisuel2.click();
      }

      // Ouvre ensuite le sélecteur du nouveau fichier.
      visuelAdhesif2.value = "";
      visuelAdhesif2.click();
    }
  );


  /* =========================================================
    NOUVELLE COMMANDE — NETTOYAGE DU VISUEL 2
    APRÈS AJOUT AU PANIER
    ========================================================= */

  window.addEventListener(
    "av:commande-reinitialisee",
    function () {

      // Efface la référence au fichier 2 dans le navigateur.
      fichierVisuelAdhesif2 = null;

      // Libère uniquement les URL temporaires locales.
      if (
        typeof urlVisuelAdhesif2 === "string" &&
        urlVisuelAdhesif2.startsWith("blob:")
      ) {
        URL.revokeObjectURL(urlVisuelAdhesif2);
      }

      urlVisuelAdhesif2 = null;

      // Vide le champ d'import.
      if (existe(visuelAdhesif2)) {
        visuelAdhesif2.value = "";
      }

      // Supprime la vignette du deuxième visuel.
      if (existe(apercuAdhesif2)) {
        apercuAdhesif2.removeAttribute("src");
      }

      masquer(apercuAdhesifBloc2);

      // Rétablit le choix par défaut.
      if (existe(memeVisuelZone2)) {
        memeVisuelZone2.checked = true;
      }

      if (existe(autreVisuelZone2)) {
        autreVisuelZone2.checked = false;
      }

      // Supprime la seconde zone et ses états de validation.
      supprimerZone2();

      // Invalide les contrôles liés à l'ancienne commande.
      controleOrientationZone2 = null;
      verificationOrientationEnCours = false;

      masquerWarningOrientation();
      mettreAJourInterface();

    }
  );

    /* =========================================================
      CHOIX VISUEL ZONE 2
    ========================================================= */

    async function changerModeVisuelZone2() {
      controleOrientationZone2 =
        null;

      masquerWarningOrientation();

      if (
        obtenirModeVisuelZone2() ===
        "autre"
      ) {
        afficher(
          importVisuelZone2,
          "flex"
        );
      }
      else {
        masquer(
          importVisuelZone2
        );
      }

      if (modeResultat) {
        activerModeSelection();
      }

      await verifierOrientationActuelle();

      mettreAJourInterface();
    }

    if (existe(memeVisuelZone2)) {
      memeVisuelZone2.addEventListener(
        "change",
        changerModeVisuelZone2
      );
    }

    if (existe(autreVisuelZone2)) {
      autreVisuelZone2.addEventListener(
        "change",
        changerModeVisuelZone2
      );
    }

    /* =========================================================
      SÉLECTIONS — INITIALISATION
    ========================================================= */

    function initialiserSelection() {
      const largeur =
        scene.clientWidth;

      const hauteur =
        scene.clientHeight;

      if (
        !largeur ||
        !hauteur
      ) {
        return;
      }

      if (
        pointsNormalises.length ===
        4
      ) {
        restaurerPoints();
        afficherSelection();

        return;
      }

      points = [
        {
          x: largeur * 0.30,
          y: hauteur * 0.25
        },
        {
          x: largeur * 0.70,
          y: hauteur * 0.25
        },
        {
          x: largeur * 0.70,
          y: hauteur * 0.75
        },
        {
          x: largeur * 0.30,
          y: hauteur * 0.75
        }
      ];

      pointsNormalises =
        calculerPointsNormalises(
          points
        );

      afficherSelection();
    }

    function initialiserSelection2() {
      const largeur =
        scene.clientWidth;

      const hauteur =
        scene.clientHeight;

      if (
        !largeur ||
        !hauteur
      ) {
        return;
      }

      if (
        pointsNormalises2.length ===
        4
      ) {
        restaurerPoints2();
        afficherSelection2();

        return;
      }

      points2 = [
        {
          x: largeur * 0.55,
          y: hauteur * 0.27
        },
        {
          x: largeur * 0.82,
          y: hauteur * 0.27
        },
        {
          x: largeur * 0.82,
          y: hauteur * 0.73
        },
        {
          x: largeur * 0.55,
          y: hauteur * 0.73
        }
      ];

      pointsNormalises2 =
        calculerPointsNormalises(
          points2
        );

      afficherSelection2();
    }

    /* =========================================================
      SÉLECTIONS — AFFICHAGE
    ========================================================= */

    function dessinerSelection(
      listePoints,
      listePoignees,
      surface,
      contour
    ) {
      if (
        listePoints.length !==
        4
      ) {
        return;
      }

      listePoignees.forEach(
        (poignee, index) => {
          if (!existe(poignee)) {
            return;
          }

          poignee.style.left =
            `${listePoints[index].x}px`;

          poignee.style.top =
            `${listePoints[index].y}px`;
        }
      );

      const chaine =
        listePoints
          .map(
            point =>
              `${point.x},${point.y}`
          )
          .join(" ");

      if (existe(surface)) {
        surface.setAttribute(
          "points",
          chaine
        );
      }

      if (existe(contour)) {
        contour.setAttribute(
          "points",
          `${chaine} ${listePoints[0].x},${listePoints[0].y}`
        );
      }
    }

    function afficherSelection() {
      dessinerSelection(
        points,
        poignees,
        surfaceVitree,
        contourVitree
      );
    }

    function afficherSelection2() {
      dessinerSelection(
        points2,
        poignees2,
        surfaceVitree2,
        contourVitree2
      );
    }

    function afficherSelectionsSelonEtat() {
      if (
        !fichierPhotoPiece ||
        modeResultat
      ) {
        return;
      }

      if (points.length === 4) {
        afficher(
          document.getElementById(
            "calqueSelection"
          )
        );

        poignees.forEach(
          poignee => {
            if (zoneVerrouillee) {
              masquer(poignee);
            }
            else {
              afficher(poignee);
            }
          }
        );

        afficherSelection();
      }

      if (
        zone2Active &&
        points2.length === 4
      ) {
        if (existe(scene)) {
          scene.classList.add(
            "zone2-active"
          );
        }

        afficher(
          calqueSelection2
        );

        poignees2.forEach(
          poignee => {
            if (zone2Verrouillee) {
              masquer(poignee);
            }
            else {
              afficher(poignee);
            }
          }
        );

        afficherSelection2();
      }
      else {
        if (existe(scene)) {
          scene.classList.remove(
            "zone2-active"
          );
        }

        masquer(
          calqueSelection2
        );

        poignees2.forEach(
          masquer
        );
      }
    }

    function masquerSelectionComplete() {
      masquer(
        document.getElementById(
          "calqueSelection"
        )
      );

      masquer(
        calqueSelection2
      );

      poignees.forEach(
        masquer
      );

      poignees2.forEach(
        masquer
      );
    }

    /* =========================================================
      DÉPLACEMENT DES POIGNÉES
    ========================================================= */

    function brancherPoignees(
      listePoignees,
      numeroZone
    ) {
      listePoignees.forEach(
        (poignee, index) => {
          if (!existe(poignee)) {
            return;
          }

          poignee.addEventListener(
            "pointerdown",
            evenement => {
              const verrouillee =
                numeroZone === 1
                  ? zoneVerrouillee
                  : zone2Verrouillee;

              if (
                verrouillee ||
                modeResultat
              ) {
                return;
              }

              if (numeroZone === 1) {
                pointActif = index;
              }
              else {
                pointActif2 = index;
              }

              poignee.setPointerCapture(
                evenement.pointerId
              );

              evenement.preventDefault();
            }
          );

          poignee.addEventListener(
            "pointermove",
            evenement => {
              const verrouillee =
                numeroZone === 1
                  ? zoneVerrouillee
                  : zone2Verrouillee;

              const actif =
                numeroZone === 1
                  ? pointActif
                  : pointActif2;

              if (
                verrouillee ||
                modeResultat ||
                actif !== index
              ) {
                return;
              }

              const rectangle =
                scene.getBoundingClientRect();

              let x =
                evenement.clientX -
                rectangle.left;

              let y =
                evenement.clientY -
                rectangle.top;

              x = Math.max(
                0,
                Math.min(
                  x,
                  rectangle.width
                )
              );

              y = Math.max(
                0,
                Math.min(
                  y,
                  rectangle.height
                )
              );

              if (numeroZone === 1) {
                points[index] = {
                  x,
                  y
                };

                pointsNormalises =
                  calculerPointsNormalises(
                    points
                  );

                controleOrientationActuel =
                  null;

                afficherSelection();
              }
              else {
                points2[index] = {
                  x,
                  y
                };

                pointsNormalises2 =
                  calculerPointsNormalises(
                    points2
                  );

                controleOrientationZone2 =
                  null;

                afficherSelection2();
              }

              masquerWarningOrientation();

              mettreAJourInterface();
            }
          );

          const terminer = () => {
            if (numeroZone === 1) {
              pointActif = null;
            }
            else {
              pointActif2 = null;
            }
          };

          poignee.addEventListener(
            "pointerup",
            terminer
          );

          poignee.addEventListener(
            "pointercancel",
            terminer
          );
        }
      );
    }

    brancherPoignees(
      poignees,
      1
    );

    brancherPoignees(
      poignees2,
      2
    );

    /* =========================================================
      COORDONNÉES NORMALISÉES
    ========================================================= */

    function calculerPointsNormalises(
      listePoints
    ) {
      const largeur =
        scene.clientWidth;

      const hauteur =
        scene.clientHeight;

      if (
        !largeur ||
        !hauteur ||
        listePoints.length !== 4
      ) {
        return [];
      }

      return listePoints.map(
        point => ({
          x:
            point.x /
            largeur,

          y:
            point.y /
            hauteur
        })
      );
    }

    function restaurerDepuisNormalises(
      listeNormalisee
    ) {
      if (
        listeNormalisee.length !==
        4
      ) {
        return [];
      }

      const largeur =
        scene.clientWidth;

      const hauteur =
        scene.clientHeight;

      return listeNormalisee.map(
        point => ({
          x:
            point.x *
            largeur,

          y:
            point.y *
            hauteur
        })
      );
    }

    function restaurerPoints() {
      const restaures =
        restaurerDepuisNormalises(
          pointsNormalises
        );

      if (restaures.length === 4) {
        points = restaures;
      }
    }

    function restaurerPoints2() {
      const restaures =
        restaurerDepuisNormalises(
          pointsNormalises2
        );

      if (restaures.length === 4) {
        points2 = restaures;
      }
    }

    /* =========================================================
      VALIDATION ZONE 1
    ========================================================= */

    if (existe(boutonValiderZone)) {
      boutonValiderZone.addEventListener(
        "click",
        async () => {
          if (
            !fichierPhotoPiece ||
            points.length !== 4
          ) {
            return;
          }

          pointsNormalises =
            calculerPointsNormalises(
              points
            );

          zoneVerrouillee = true;

          if (existe(scene)) {
            scene.classList.add(
              "zone-verrouillee"
            );
          }

          masquer(
            boutonValiderZone
          );

          afficher(
            zoneValidee,
            "flex"
          );

          poignees.forEach(
            masquer
          );

          if (existe(aideSelection)) {
            aideSelection.textContent =
              "✓ Votre zone de vitrage est validée.";
          }

         
masquer(ajoutZone2);

          await verifierOrientationActuelle();

          mettreAJourInterface();
        }
      );
    }

    /* =========================================================
      MODIFIER ZONE 1
    ========================================================= */

    
function modifierZone() {
  // 1. Sortir de la simulation et déverrouiller la zone.
  modeResultat = false;
  zoneVerrouillee = false;
  pointActif = null;

  controleOrientationActuel = null;
  verificationOrientationEnCours = false;

  masquerWarningOrientation();

  // 2. Supprimer les états visuels du résultat et du verrouillage.
  if (existe(scene)) {
    scene.classList.remove(
      "mode-resultat",
      "zone-verrouillee"
    );
  }

  masquer(canvasResultat);
  masquer(actionsResultatScene);
  masquer(badgeSimulation);
  masquer(noteSimulation);

  // 3. Rétablir la photo de la pièce.
  afficher(photo);
  afficher(actionsPhoto, "flex");

  // 4. Restaurer les coordonnées précédemment validées.
  restaurerPoints();

  // 5. Rendre le calque et les quatre poignées visibles.
  const calqueSelection =
    document.getElementById("calqueSelection");

  afficher(calqueSelection);

  poignees.forEach((poignee) => {
    afficher(poignee);
  });

  afficherSelection();

  // 6. Revenir à la validation de la zone.
  afficher(validationZone);

  if (existe(boutonValiderZone)) {
    afficher(boutonValiderZone, "inline-flex");
  }

  masquer(zoneValidee);
  masquer(ajoutZone2);

  if (existe(aideSelection)) {
    aideSelection.textContent =
      "Déplacez les 4 points sur les coins exacts de votre vitrage.";

    afficher(aideSelection);
  }

  // 7. Actualiser les étapes et désactiver la simulation
  // tant que la zone n'a pas été revalidée.
  mettreAJourInterface();
}


    if (existe(boutonModifierZone)) {
      boutonModifierZone.addEventListener(
        "click",
        modifierZone
      );
    }

    /* =========================================================
      AJOUTER / VALIDER / MODIFIER / SUPPRIMER ZONE 2
    ========================================================= */

    if (
      existe(
        boutonAjouterZone2
      )
    ) {
      boutonAjouterZone2.addEventListener(
        "click",
        () => {          
      // VISUALISEUR 2 : ajout d'une deuxième zone interdit.
      return;

          if (!zoneVerrouillee) {
            return;
          }

          zone2Active = true;
          zone2Verrouillee = false;

          controleOrientationZone2 =
            null;

          masquerWarningOrientation();

          if (existe(scene)) {
            scene.classList.add(
              "zone2-active"
            );
          }

          masquer(
            ajoutZone2
          );

          masquer(
            zoneValidee2
          );

          afficher(
            validationZone2
          );

          afficher(
            carteVisuelZone2
          );

          initialiserSelection2();

          afficher(
            calqueSelection2
          );

          poignees2.forEach(
            poignee =>
              afficher(poignee)
          );

          if (
            obtenirModeVisuelZone2() ===
            "autre"
          ) {
            afficher(
              importVisuelZone2,
              "flex"
            );
          }

          mettreAJourInterface();
        }
      );
    }

    if (
      existe(
        boutonValiderZone2
      )
    ) {
      boutonValiderZone2.addEventListener(
        "click",
        async () => {
          if (
            !zone2Active ||
            points2.length !== 4
          ) {
            return;
          }

          pointsNormalises2 =
            calculerPointsNormalises(
              points2
            );

          zone2Verrouillee = true;

          controleOrientationZone2 =
            null;

          masquer(
            validationZone2
          );

          afficher(
            zoneValidee2,
            "flex"
          );

          afficher(
            carteVisuelZone2
          );

          poignees2.forEach(
            masquer
          );

          await verifierOrientationActuelle();

          mettreAJourInterface();
        }
      );
    }

    function modifierZone2() {
      if (!zone2Active) {
        return;
      }

      activerModeSelection();

      zone2Verrouillee = false;

      controleOrientationZone2 =
        null;

      verificationOrientationEnCours =
        false;

      masquerWarningOrientation();

      restaurerPoints2();

      afficherSelection2();

      afficher(
        calqueSelection2
      );

      poignees2.forEach(
        poignee =>
          afficher(poignee)
      );

      masquer(
        zoneValidee2
      );

      afficher(
        validationZone2
      );

      afficher(
        carteVisuelZone2
      );

      mettreAJourInterface();
    }

    if (existe(boutonModifierZone2)) {
      boutonModifierZone2.addEventListener(
        "click",
        modifierZone2
      );
    }

    function supprimerZone2() {
      zone2Active = false;
      zone2Verrouillee = false;

      points2 = [];
      pointsNormalises2 = [];

      pointActif2 = null;

      controleOrientationZone2 =
        null;

      warningZoneActuelle = 1;

      masquerWarningOrientation();

      masquer(
        validationZone2
      );

      masquer(
        zoneValidee2
      );

      masquer(
        carteVisuelZone2
      );

      masquer(
        importVisuelZone2
      );

      masquer(
        calqueSelection2
      );

      poignees2.forEach(
        masquer
      );

      if (existe(scene)) {
        scene.classList.remove(
          "zone2-active"
        );
      }

      if (zoneVerrouillee) {
        afficher(
          ajoutZone2,
          "flex"
        );
      }

      if (modeResultat) {
        activerModeSelection();
      }

      mettreAJourInterface();
    }

    if (
      existe(
        boutonSupprimerZone2
      )
    ) {
      boutonSupprimerZone2.addEventListener(
        "click",
        supprimerZone2
      );
    }

    /* =========================================================
      BOUTONS DU WARNING
    ========================================================= */

    if (
      existe(
        warningChangerVisuel
      )
    ) {
      warningChangerVisuel.addEventListener(
        "click",
        () => {
          if (
            warningZoneActuelle === 2 &&
            obtenirModeVisuelZone2() ===
              "autre"
          ) {
            visuelAdhesif2.click();
          }
          else if (
      visuelPrincipalDepuisConfigurateur
    ) {
      /*
      * Le visuel principal appartient déjà à la commande.
      * On ne permet pas de le remplacer depuis le visualiseur.
      * En cas d'incompatibilité, on propose donc de modifier
      * la zone de vitrage.
      */
      modifierZone();
    }
    else {
      visuelAdhesif.click();
    }
        }
      );
    }

    if (
      existe(
        warningModifierZone
      )
    ) {
      warningModifierZone.addEventListener(
        "click",
        () => {
          if (
            warningZoneActuelle === 2
          ) {
            modifierZone2();
          }
          else {
            modifierZone();
          }
        }
      );
    }

    /* =========================================================
      RÉINITIALISER
    ========================================================= */

    if (
      existe(
        boutonReinitialiser
      )
    ) {
      boutonReinitialiser.addEventListener(
        "click",
        () => {
          zoneVerrouillee = false;

          zone2Active = false;
          zone2Verrouillee = false;

          points = [];
          pointsNormalises = [];

          points2 = [];
          pointsNormalises2 = [];

          verificationOrientationEnCours =
            false;

          invaliderControlesOrientation();

          if (existe(scene)) {
            scene.classList.remove(
              "zone-verrouillee",
              "zone2-active"
            );
          }

          masquer(
            zoneValidee
          );

          masquer(
            zoneValidee2
          );

          masquer(
            validationZone2
          );

          masquer(
            ajoutZone2
          );

          masquer(
            carteVisuelZone2
          );

          masquer(
            calqueSelection2
          );

          poignees2.forEach(
            masquer
          );

          if (
            existe(
              boutonValiderZone
            )
          ) {
            boutonValiderZone.style.display =
              "inline-flex";
          }

          if (existe(aideSelection)) {
            aideSelection.textContent =
              "Positionnez précisément les 4 points sur les coins de votre vitrage.";
          }

          initialiserSelection();

          activerModeSelection();
        }
      );
    }

    /* =========================================================
      PROGRESSION
    ========================================================= */

    function etatEtape(
      element,
      terminee,
      active
    ) {
      if (!existe(element)) {
        return;
      }

      element.classList.toggle(
        "progression-etape--terminee",
        terminee
      );

      element.classList.toggle(
        "progression-etape--active",
        active
      );
    }

    /* =========================================================
      INTERFACE
    ========================================================= */
  
  function notifierConfigurationZones() {
    // Visualiseur 2 : une seule zone de vitrage.
    // Aucun événement envoyé au configurateur Shopify.
    // Fonction conservée pour les appels internes du moteur V5.
    return;
  }


    function mettreAJourInterface() {
      
  // VISUALISEUR 2 : une seule zone autorisée.
  zone2Active = false;

    notifierConfigurationZones();
    
      if (modeResultat) {
        return;
      }

      etatEtape(
        etape1,
        Boolean(fichierPhotoPiece),
        !fichierPhotoPiece
      );

      const zonesValidees =
        zoneVerrouillee &&
        (
          !zone2Active ||
          zone2Verrouillee
        );

      etatEtape(
        etape2,
        zonesValidees,
        Boolean(fichierPhotoPiece) &&
          !zonesValidees
      );

      const visuelsPrets =
        Boolean(
          fichierVisuelAdhesif
        ) &&
        zone2Prete();

      etatEtape(
        etape3,
        visuelsPrets,
        zonesValidees &&
          !visuelsPrets
      );

      if (
        zoneVerrouillee &&
        !zone2Active
      ) {
        afficher(
          ajoutZone2,
          "flex"
        );
      }
      else {
        masquer(
          ajoutZone2
        );
      }

      if (zone2Active) {
        afficher(
          carteVisuelZone2
        );

        
      // La vignette 2 n'apparaît que si un fichier 2 existe.
      if (fichierVisuelAdhesif2) {
        afficher(
          apercuAdhesifBloc2,
          "flex"
        );
      } else {
        if (existe(apercuAdhesif2)) {
          apercuAdhesif2.removeAttribute("src");
        }

        masquer(
          apercuAdhesifBloc2
        );
      }

      /* =========================================================
    VISUEL 2 — VERROUILLAGE DU BOUTON D'IMPORT
    ========================================================= */

  const boutonImportVisuel2 =
    document.querySelector('label[for="visuelAdhesif2"]');

  if (boutonImportVisuel2) {
    const fichier2DejaImporte =
      Boolean(fichierVisuelAdhesif2);

    boutonImportVisuel2.style.opacity =
      fichier2DejaImporte ? "0.45" : "";

    boutonImportVisuel2.style.pointerEvents =
      fichier2DejaImporte ? "none" : "";

    boutonImportVisuel2.style.cursor =
      fichier2DejaImporte ? "not-allowed" : "";

    boutonImportVisuel2.setAttribute(
      "aria-disabled",
      String(fichier2DejaImporte)
    );
  }


        if (
          obtenirModeVisuelZone2() ===
          "autre"
        ) {
          afficher(
            importVisuelZone2,
            "flex"
          );
        }
        else {
          masquer(
            importVisuelZone2
          );
        }
      }
      else {
        masquer(
          carteVisuelZone2
        );
      }

      const incompatibleZone1 =
        controleOrientationActuel &&
        controleOrientationActuel.compatible ===
          false;

      const incompatibleZone2 =
        zone2Active &&
        controleOrientationZone2 &&
        controleOrientationZone2.compatible ===
          false;

      const pretDeBase =
        Boolean(
          fichierPhotoPiece
        ) &&
        zoneVerrouillee &&
        (
          !zone2Active ||
          zone2Verrouillee
        ) &&
        Boolean(
          fichierVisuelAdhesif
        ) &&
        zone2Prete();

      if (existe(boutonVisualiser)) {
        boutonVisualiser.disabled =
          !pretDeBase ||
          incompatibleZone1 ||
          incompatibleZone2 ||
          verificationOrientationEnCours;
      }

      if (!existe(messageEtat)) {
        return;
      }

      if (!fichierPhotoPiece) {
        messageEtat.textContent =
          "Ajoutez votre photo pour commencer.";
      }
      else if (!zoneVerrouillee) {
        messageEtat.textContent =
        "Définissez puis validez votre zone de vitrage.";
      }
      else if (
        zone2Active &&
        !zone2Verrouillee
      ) {
        messageEtat.textContent =
          "Définissez puis validez votre seconde zone de vitrage.";
      }
      else if (
        !fichierVisuelAdhesif
      ) {
        messageEtat.textContent =
          "Importez maintenant votre visuel vitrail.";
      }
      else if (
        zone2Active &&
        obtenirModeVisuelZone2() ===
          "autre" &&
        !fichierVisuelAdhesif2
      ) {
        messageEtat.textContent =
          "Importez le visuel destiné à la seconde zone.";
      }
      else if (
        verificationOrientationEnCours
      ) {
        messageEtat.textContent =
          "Vérification de vos visuels...";
      }
      else if (
        incompatibleZone1 ||
        incompatibleZone2
      ) {
        const numero =
          incompatibleZone1
            ? 1
            : 2;

        messageEtat.textContent =
          zone2Active
            ? `Choisissez un visuel adapté à l’orientation de la zone ${numero}.`
            : "Choisissez un visuel adapté à l’orientation de votre vitrage.";
      }
      else {
        messageEtat.textContent =
          zone2Active
            ? "Tout est prêt pour visualiser vos deux vitrages."
            : "Tout est prêt pour créer votre visualisation.";
      }
    }

    /* =========================================================
      OUTILS GÉOMÉTRIQUES
    ========================================================= */

    function distancePoints(
      pointA,
      pointB
    ) {
      return Math.hypot(
        pointB.x - pointA.x,
        pointB.y - pointA.y
      );
    }

    function calculerRatioDestination(
      destination
    ) {
      const largeurHaut =
        distancePoints(
          destination[0],
          destination[1]
        );

      const largeurBas =
        distancePoints(
          destination[3],
          destination[2]
        );

      const hauteurGauche =
        distancePoints(
          destination[0],
          destination[3]
        );

      const hauteurDroite =
        distancePoints(
          destination[1],
          destination[2]
        );

      const largeurMoyenne =
        (
          largeurHaut +
          largeurBas
        ) / 2;

      const hauteurMoyenne =
        (
          hauteurGauche +
          hauteurDroite
        ) / 2;

      if (
        largeurMoyenne <= 0 ||
        hauteurMoyenne <= 0
      ) {
        return 1;
      }

      return (
        largeurMoyenne /
        hauteurMoyenne
      );
    }

    /* =========================================================
      ORIENTATION
    ========================================================= */

    function determinerOrientation(
      ratio
    ) {
      if (
        ratio <
        SEUIL_VERTICAL
      ) {
        return "vertical";
      }

      if (
        ratio >
        SEUIL_HORIZONTAL
      ) {
        return "horizontal";
      }

      return "adaptable";
    }

    function verifierCompatibiliteOrientation(
      image,
      destination
    ) {
      const largeurImage =
        image.naturalWidth ||
        image.width;

      const hauteurImage =
        image.naturalHeight ||
        image.height;

      if (
        !largeurImage ||
        !hauteurImage
      ) {
        return {
          compatible: true,
          orientationVitrage:
            "adaptable",
          orientationVisuel:
            "adaptable"
        };
      }

      const ratioVisuel =
        largeurImage /
        hauteurImage;

      const ratioVitrage =
        calculerRatioDestination(
          destination
        );

      const orientationVisuel =
        determinerOrientation(
          ratioVisuel
        );

      const orientationVitrage =
        determinerOrientation(
          ratioVitrage
        );

      if (
        orientationVisuel ===
          "adaptable" ||
        orientationVitrage ===
          "adaptable"
      ) {
        return {
          compatible: true,
          orientationVitrage,
          orientationVisuel,
          ratioVitrage,
          ratioVisuel
        };
      }

      return {
        compatible:
          orientationVisuel ===
          orientationVitrage,

        orientationVitrage,
        orientationVisuel,
        ratioVitrage,
        ratioVisuel
      };
    }

    /* =========================================================
      DESTINATION RÉELLE
    ========================================================= */

    function obtenirDestinationNaturelle(
      imagePiece,
      listeNormalisee
    ) {
      const largeurPhoto =
        imagePiece.naturalWidth ||
        imagePiece.width;

      const hauteurPhoto =
        imagePiece.naturalHeight ||
        imagePiece.height;

      return listeNormalisee.map(
        point => ({
          x:
            point.x *
            largeurPhoto,

          y:
            point.y *
            hauteurPhoto
        })
      );
    }

    /* =========================================================
      VÉRIFICATION PRÉVENTIVE ORIENTATION — 1 OU 2 ZONES
    ========================================================= */

    async function verifierOrientationActuelle() {
      controleOrientationActuel =
        null;

      controleOrientationZone2 =
        null;

      masquerWarningOrientation();

      if (
        !fichierPhotoPiece ||
        !fichierVisuelAdhesif ||
        !zoneVerrouillee ||
        pointsNormalises.length !== 4
      ) {
        verificationOrientationEnCours =
          false;

        mettreAJourInterface();

        return true;
      }

      if (
        zone2Active &&
        (
          !zone2Verrouillee ||
          !obtenirFichierZone2()
        )
      ) {
        verificationOrientationEnCours =
          false;

        mettreAJourInterface();

        return true;
      }

      verificationOrientationEnCours =
        true;

      mettreAJourInterface();

      try {
        const imagePiece =
          await chargerImage(
            urlPhotoPiece
          );

        const imageVisuel1 =
          await chargerImage(
            urlVisuelAdhesif
          );

        const destination1 =
          obtenirDestinationNaturelle(
            imagePiece,
            pointsNormalises
          );

        controleOrientationActuel =
          verifierCompatibiliteOrientation(
            imageVisuel1,
            destination1
          );

        if (
          !controleOrientationActuel.compatible
        ) {
          afficherWarningOrientation(
            controleOrientationActuel,
            1
          );

          return false;
        }

        if (zone2Active) {
          const urlZone2 =
            obtenirURLZone2();

          const imageVisuel2 =
            obtenirModeVisuelZone2() ===
              "meme"
              ? imageVisuel1
              : await chargerImage(
                  urlZone2
                );

          const destination2 =
            obtenirDestinationNaturelle(
              imagePiece,
              pointsNormalises2
            );

          controleOrientationZone2 =
            verifierCompatibiliteOrientation(
              imageVisuel2,
              destination2
            );

          if (
            !controleOrientationZone2.compatible
          ) {
            afficherWarningOrientation(
              controleOrientationZone2,
              2
            );

            return false;
          }
        }

        masquerWarningOrientation();

        return true;
      }

      catch (erreur) {
        console.error(
          "[Adhésif-Vitrail] Vérification orientation :",
          erreur
        );

        controleOrientationActuel =
          null;

        controleOrientationZone2 =
          null;

        return true;
      }

      finally {
        verificationOrientationEnCours =
          false;

        mettreAJourInterface();
      }
    }

    /* =========================================================
      CADRAGE ADAPTATIF — MOTEUR V4 CONSERVÉ
    ========================================================= */

    function calculerCadrageAdaptatif(
      image,
      destination
    ) {
      const largeurImage =
        image.naturalWidth ||
        image.width;

      const hauteurImage =
        image.naturalHeight ||
        image.height;

      const ratioSource =
        largeurImage /
        hauteurImage;

      const ratioDestination =
        calculerRatioDestination(
          destination
        );

      const ecartLog =
        Math.log(
          ratioDestination /
          ratioSource
        );

      const amplitudeEcart =
        Math.abs(
          ecartLog
        );

      if (
        amplitudeEcart <=
        TOLERANCE_LIBRE
      ) {
        return {
          x: 0,
          y: 0,

          largeur:
            largeurImage,

          hauteur:
            hauteurImage,

          ratioSource,
          ratioDestination,

          deformationResiduelle:
            ecartLog,

          recadrageActif:
            false
        };
      }

      const signe =
        Math.sign(
          ecartLog
        ) || 1;

      const depassement =
        amplitudeEcart -
        TOLERANCE_LIBRE;

      const margeProgressive =
        TOLERANCE_LIBRE +
        (
          DEFORMATION_MAX -
          TOLERANCE_LIBRE
        ) *
        (
          1 -
          Math.exp(
            -depassement * 5
          )
        );

      const deformationResiduelle =
        signe *
        Math.min(
          amplitudeEcart,
          margeProgressive
        );

      const ratioCadreSource =
        ratioDestination /
        Math.exp(
          deformationResiduelle
        );

      let largeurCadre =
        largeurImage;

      let hauteurCadre =
        hauteurImage;

      let x = 0;
      let y = 0;

      if (
        ratioSource >
        ratioCadreSource
      ) {
        hauteurCadre =
          hauteurImage;

        largeurCadre =
          hauteurImage *
          ratioCadreSource;

        largeurCadre =
          Math.min(
            largeurImage,
            largeurCadre
          );

        x =
          (
            largeurImage -
            largeurCadre
          ) *
          POSITION_CADRAGE_X;
      }

      else if (
        ratioSource <
        ratioCadreSource
      ) {
        largeurCadre =
          largeurImage;

        hauteurCadre =
          largeurImage /
          ratioCadreSource;

        hauteurCadre =
          Math.min(
            hauteurImage,
            hauteurCadre
          );

        y =
          (
            hauteurImage -
            hauteurCadre
          ) *
          POSITION_CADRAGE_Y;
      }

      largeurCadre =
        Math.max(
          1,
          largeurCadre
        );

      hauteurCadre =
        Math.max(
          1,
          hauteurCadre
        );

      x =
        Math.max(
          0,
          Math.min(
            x,
            largeurImage -
            largeurCadre
          )
        );

      y =
        Math.max(
          0,
          Math.min(
            y,
            hauteurImage -
            hauteurCadre
          )
        );

      return {
        x,
        y,

        largeur:
          largeurCadre,

        hauteur:
          hauteurCadre,

        ratioSource,
        ratioDestination,

        deformationResiduelle,

        recadrageActif:
          (
            largeurCadre <
            largeurImage - 0.5
          ) ||
          (
            hauteurCadre <
            hauteurImage - 0.5
          )
      };
    }

    /* =========================================================
      SYSTÈME LINÉAIRE
    ========================================================= */

    function resoudreSysteme(
      A,
      b
    ) {
      const n =
        b.length;

      const matrice =
        A.map(
          (ligne, index) => [
            ...ligne,
            b[index]
          ]
        );

      for (
        let colonne = 0;
        colonne < n;
        colonne++
      ) {
        let pivot =
          colonne;

        for (
          let ligne =
            colonne + 1;

          ligne < n;

          ligne++
        ) {
          if (
            Math.abs(
              matrice[ligne][colonne]
            ) >
            Math.abs(
              matrice[pivot][colonne]
            )
          ) {
            pivot =
              ligne;
          }
        }

        if (
          Math.abs(
            matrice[pivot][colonne]
          ) < 1e-12
        ) {
          throw new Error(
            "Zone impossible à calculer."
          );
        }

        if (
          pivot !==
          colonne
        ) {
          const temp =
            matrice[colonne];

          matrice[colonne] =
            matrice[pivot];

          matrice[pivot] =
            temp;
        }

        const valeur =
          matrice[colonne][colonne];

        for (
          let j = colonne;
          j <= n;
          j++
        ) {
          matrice[colonne][j] /=
            valeur;
        }

        for (
          let ligne = 0;
          ligne < n;
          ligne++
        ) {
          if (
            ligne ===
            colonne
          ) {
            continue;
          }

          const facteur =
            matrice[ligne][colonne];

          for (
            let j = colonne;
            j <= n;
            j++
          ) {
            matrice[ligne][j] -=
              facteur *
              matrice[colonne][j];
          }
        }
      }

      return matrice.map(
        ligne =>
          ligne[n]
      );
    }

    /* =========================================================
      HOMOGRAPHIE
    ========================================================= */

    function calculerHomographie(
      destination
    ) {
      const source = [
        {
          x: 0,
          y: 0
        },
        {
          x: 1,
          y: 0
        },
        {
          x: 1,
          y: 1
        },
        {
          x: 0,
          y: 1
        }
      ];

      const A = [];
      const b = [];

      for (
        let i = 0;
        i < 4;
        i++
      ) {
        const x =
          source[i].x;

        const y =
          source[i].y;

        const X =
          destination[i].x;

        const Y =
          destination[i].y;

        A.push([
          x,
          y,
          1,

          0,
          0,
          0,

          -x * X,
          -y * X
        ]);

        b.push(X);

        A.push([
          0,
          0,
          0,

          x,
          y,
          1,

          -x * Y,
          -y * Y
        ]);

        b.push(Y);
      }

      const h =
        resoudreSysteme(
          A,
          b
        );

      return [
        h[0],
        h[1],
        h[2],

        h[3],
        h[4],
        h[5],

        h[6],
        h[7],
        1
      ];
    }

    /* =========================================================
      PROJETER POINT
    ========================================================= */

    function projeterPoint(
      matrice,
      u,
      v
    ) {
      const w =
        matrice[6] * u +
        matrice[7] * v +
        matrice[8];

      return {
        x:
          (
            matrice[0] * u +
            matrice[1] * v +
            matrice[2]
          ) / w,

        y:
          (
            matrice[3] * u +
            matrice[4] * v +
            matrice[5]
          ) / w
      };
    }

    /* =========================================================
      TRIANGLE — MOTEUR V4 CONSERVÉ
    ========================================================= */

    function dessinerTriangle(
      contexte,
      image,
      s0,
      s1,
      s2,
      d0,
      d1,
      d2
    ) {
      const den =
        s0.x *
          (
            s1.y -
            s2.y
          ) +
        s1.x *
          (
            s2.y -
            s0.y
          ) +
        s2.x *
          (
            s0.y -
            s1.y
          );

      if (
        Math.abs(den) <
        0.000001
      ) {
        return;
      }

      const a =
        (
          d0.x *
            (
              s1.y -
              s2.y
            ) +
          d1.x *
            (
              s2.y -
              s0.y
            ) +
          d2.x *
            (
              s0.y -
              s1.y
            )
        ) / den;

      const c =
        (
          d0.x *
            (
              s2.x -
              s1.x
            ) +
          d1.x *
            (
              s0.x -
              s2.x
            ) +
          d2.x *
            (
              s1.x -
              s0.x
            )
        ) / den;

      const e =
        (
          d0.x *
            (
              s1.x *
                s2.y -
              s2.x *
                s1.y
            ) +

          d1.x *
            (
              s2.x *
                s0.y -
              s0.x *
                s2.y
            ) +

          d2.x *
            (
              s0.x *
                s1.y -
              s1.x *
                s0.y
            )
        ) / den;

      const b =
        (
          d0.y *
            (
              s1.y -
              s2.y
            ) +
          d1.y *
            (
              s2.y -
              s0.y
            ) +
          d2.y *
            (
              s0.y -
              s1.y
            )
        ) / den;

      const d =
        (
          d0.y *
            (
              s2.x -
              s1.x
            ) +
          d1.y *
            (
              s0.x -
              s2.x
            ) +
          d2.y *
            (
              s1.x -
              s0.x
            )
        ) / den;

      const f =
        (
          d0.y *
            (
              s1.x *
                s2.y -
              s2.x *
                s1.y
            ) +

          d1.y *
            (
              s2.x *
                s0.y -
              s0.x *
                s2.y
            ) +

          d2.y *
            (
              s0.x *
                s1.y -
              s1.x *
                s0.y
            )
        ) / den;

      contexte.save();

      const centreX =
        (
          d0.x +
          d1.x +
          d2.x
        ) / 3;

      const centreY =
        (
          d0.y +
          d1.y +
          d2.y
        ) / 3;

      function agrandir(point) {
        const dx =
          point.x -
          centreX;

        const dy =
          point.y -
          centreY;

        const longueur =
          Math.hypot(
            dx,
            dy
          ) || 1;

        return {
          x:
            point.x +
            (
              dx /
              longueur
            ) *
            0.8,

          y:
            point.y +
            (
              dy /
              longueur
            ) *
            0.8
        };
      }

      const c0 =
        agrandir(d0);

      const c1 =
        agrandir(d1);

      const c2 =
        agrandir(d2);

      contexte.beginPath();

      contexte.moveTo(
        c0.x,
        c0.y
      );

      contexte.lineTo(
        c1.x,
        c1.y
      );

      contexte.lineTo(
        c2.x,
        c2.y
      );

      contexte.closePath();

      contexte.clip();

      contexte.setTransform(
        a,
        b,
        c,
        d,
        e,
        f
      );

      contexte.drawImage(
        image,
        0,
        0
      );

      contexte.restore();
    }

    /* =========================================================
      PROJECTION DU VISUEL — MOTEUR V4 CONSERVÉ
    ========================================================= */

    function projeterVisuel(
      contexte,
      image,
      destination,
      etiquette = "Zone"
    ) {
      const homographie =
        calculerHomographie(
          destination
        );

      const cadrage =
        calculerCadrageAdaptatif(
          image,
          destination
        );

      contexte.save();

      contexte.globalAlpha =
        OPACITE_ADHESIF;

      contexte.globalCompositeOperation =
        "source-over";

      for (
        let ligne = 0;
        ligne < SUBDIVISIONS;
        ligne++
      ) {
        const v0 =
          ligne /
          SUBDIVISIONS;

        const v1 =
          (
            ligne + 1
          ) /
          SUBDIVISIONS;

        for (
          let colonne = 0;
          colonne < SUBDIVISIONS;
          colonne++
        ) {
          const u0 =
            colonne /
            SUBDIVISIONS;

          const u1 =
            (
              colonne + 1
            ) /
            SUBDIVISIONS;

          const d00 =
            projeterPoint(
              homographie,
              u0,
              v0
            );

          const d10 =
            projeterPoint(
              homographie,
              u1,
              v0
            );

          const d11 =
            projeterPoint(
              homographie,
              u1,
              v1
            );

          const d01 =
            projeterPoint(
              homographie,
              u0,
              v1
            );

          const s00 = {
            x:
              cadrage.x +
              u0 *
              cadrage.largeur,

            y:
              cadrage.y +
              v0 *
              cadrage.hauteur
          };

          const s10 = {
            x:
              cadrage.x +
              u1 *
              cadrage.largeur,

            y:
              cadrage.y +
              v0 *
              cadrage.hauteur
          };

          const s11 = {
            x:
              cadrage.x +
              u1 *
              cadrage.largeur,

            y:
              cadrage.y +
              v1 *
              cadrage.hauteur
          };

          const s01 = {
            x:
              cadrage.x +
              u0 *
              cadrage.largeur,

            y:
              cadrage.y +
              v1 *
              cadrage.hauteur
          };

          dessinerTriangle(
            contexte,
            image,

            s00,
            s10,
            s11,

            d00,
            d10,
            d11
          );

          dessinerTriangle(
            contexte,
            image,

            s00,
            s11,
            s01,

            d00,
            d11,
            d01
          );
        }
      }

      contexte.restore();

      console.log(
        `[Adhésif-Vitrail] Projection adaptative — ${etiquette}`,
        {
          ratioVisuel:
            Number(
              cadrage.ratioSource.toFixed(
                3
              )
            ),

          ratioVitrage:
            Number(
              cadrage.ratioDestination.toFixed(
                3
              )
            ),

          recadrage:
            cadrage.recadrageActif,

          zoneSource: {
            x:
              Math.round(
                cadrage.x
              ),

            y:
              Math.round(
                cadrage.y
              ),

            largeur:
              Math.round(
                cadrage.largeur
              ),

            hauteur:
              Math.round(
                cadrage.hauteur
              )
          }
        }
      );
    }

    /* =========================================================
      CRÉER LE RÉSULTAT — 1 OU 2 PROJECTIONS
    ========================================================= */

    async function creerVisualisation() {
      if (
        !fichierPhotoPiece ||
        !fichierVisuelAdhesif ||
        !zoneVerrouillee ||
        pointsNormalises.length !== 4 ||
        !zone2Prete()
      ) {
        return false;
      }

      const imagePiece =
        await chargerImage(
          urlPhotoPiece
        );

      const imageVisuel1 =
        await chargerImage(
          urlVisuelAdhesif
        );

      const largeurPhoto =
        imagePiece.naturalWidth ||
        imagePiece.width;

      const hauteurPhoto =
        imagePiece.naturalHeight ||
        imagePiece.height;

      const destination1 =
        obtenirDestinationNaturelle(
          imagePiece,
          pointsNormalises
        );

      const controle1 =
        verifierCompatibiliteOrientation(
          imageVisuel1,
          destination1
        );

      controleOrientationActuel =
        controle1;

      if (!controle1.compatible) {
        afficherWarningOrientation(
          controle1,
          1
        );

        mettreAJourInterface();

        return false;
      }

      let imageVisuel2 =
        null;

      let destination2 =
        null;

      if (zone2Active) {
        imageVisuel2 =
          obtenirModeVisuelZone2() ===
            "meme"
            ? imageVisuel1
            : await chargerImage(
                urlVisuelAdhesif2
              );

        destination2 =
          obtenirDestinationNaturelle(
            imagePiece,
            pointsNormalises2
          );

        const controle2 =
          verifierCompatibiliteOrientation(
            imageVisuel2,
            destination2
          );

        controleOrientationZone2 =
          controle2;

        if (!controle2.compatible) {
          afficherWarningOrientation(
            controle2,
            2
          );

          mettreAJourInterface();

          return false;
        }
      }

      masquerWarningOrientation();

      canvasResultat.width =
        largeurPhoto;

      canvasResultat.height =
        hauteurPhoto;

      const contexte =
        canvasResultat.getContext(
          "2d"
        );

      contexte.setTransform(
        1,
        0,
        0,
        1,
        0,
        0
      );

      contexte.globalAlpha =
        1;

      contexte.globalCompositeOperation =
        "source-over";

      contexte.clearRect(
        0,
        0,
        largeurPhoto,
        hauteurPhoto
      );

      contexte.drawImage(
        imagePiece,
        0,
        0,
        largeurPhoto,
        hauteurPhoto
      );

      projeterVisuel(
        contexte,
        imageVisuel1,
        destination1,
        "Zone 1"
      );

      if (
        zone2Active &&
        imageVisuel2 &&
        destination2
      ) {
        projeterVisuel(
          contexte,
          imageVisuel2,
          destination2,
          "Zone 2"
        );
      }

          activerModeResultat();

      window.dispatchEvent(
        new CustomEvent("av:simulation-reussie")
      );

      return true;
    }

    /* =========================================================
      VISUALISER CHEZ MOI
    ========================================================= */

    if (
      existe(
        boutonVisualiser
      )
    ) {
      boutonVisualiser.addEventListener(
        "click",
        async () => {
          if (
            !fichierPhotoPiece ||
            !zoneVerrouillee ||
            !fichierVisuelAdhesif ||
            !zone2Prete()
          ) {
            return;
          }

          const compatible =
            await verifierOrientationActuelle();

          if (!compatible) {
            return;
          }

          const ancienTexte =
            boutonVisualiser.innerHTML;

          boutonVisualiser.disabled =
            true;

          boutonVisualiser.innerHTML =
            "<span>⏳</span> Création du rendu...";

          if (existe(messageEtat)) {
            messageEtat.textContent =
              zone2Active
                ? "Projection de vos deux visuels en cours..."
                : "Analyse et projection de votre visuel en cours...";
          }

          try {
            await creerVisualisation();
          }

          catch (erreur) {
            console.error(
              erreur
            );

            alert(
              "La simulation n'a pas pu être créée."
            );
          }

          finally {
            boutonVisualiser.innerHTML =
              ancienTexte;

            if (!modeResultat) {
              mettreAJourInterface();
            }
          }
        }
      );
    }

    /* =========================================================
      ACTIONS DU RÉSULTAT
    ========================================================= */

    if (existe(boutonModifierSimulation)) {
  boutonModifierSimulation.addEventListener("click", () => {
    // Revenir directement à l'édition des 4 points,
    // sans perdre la photo ni le modèle Shopify.
    modifierZone();
  });
}

    
    if (existe(boutonNouvelleSimulation)) {
      boutonNouvelleSimulation.addEventListener("click", () => {
        // Visualiseur 2 : le vitrail vient automatiquement de Shopify.
        // Une nouvelle simulation nécessite seulement une photo de pièce.
        if (existe(photoPiece)) {
          photoPiece.click();
        }
      });
    }


    /* =========================================================
      REDIMENSIONNEMENT
    ========================================================= */

    window.addEventListener(
      "resize",
      () => {
        if (
          !fichierPhotoPiece ||
          pointsNormalises.length !== 4
        ) {
          return;
        }

        requestAnimationFrame(
          () => {
            restaurerPoints();

            afficherSelection();

            if (
              zone2Active &&
              pointsNormalises2.length ===
                4
            ) {
              restaurerPoints2();

              afficherSelection2();
            }
          }
        );
      }
    );

    /* =========================================================
      NETTOYAGE
    ========================================================= */

    function revoquerURLSiBlob(url) {
      if (
        typeof url === "string" &&
        url.startsWith("blob:")
      ) {
        URL.revokeObjectURL(url);
      }
    }

    window.addEventListener(
      "beforeunload",
      () => {
        /*
        * Les URL créées localement avec createObjectURL
        * peuvent être libérées.
        *
        * L'URL HTTP du FINAL/NORMALISÉ provenant du backend
        * ne doit surtout pas être révoquée.
        */
        revoquerURLSiBlob(
          urlPhotoPiece
        );

        revoquerURLSiBlob(
          urlVisuelAdhesif
        );

        revoquerURLSiBlob(
          urlVisuelAdhesif2
        );

        /*
        * On arrête simplement le timer local.
        * On ne supprime évidemment PAS le fichier backend.
        */
        if (heartbeatVisualiseurTimer) {
          clearInterval(
            heartbeatVisualiseurTimer
          );

          heartbeatVisualiseurTimer =
            null;
        }
      }
    );

    /* =========================================================
      ACTIVITÉ BACKEND PENDANT LE VISUALISEUR
    ========================================================= */

    document.addEventListener(
      "visibilitychange",
      () => {
        if (
          document.visibilityState ===
          "visible"
        ) {
          envoyerHeartbeatVisualiseur(
            false
          );
        }
      }
    );

    window.addEventListener(
      "focus",
      () => {
        envoyerHeartbeatVisualiseur(
          false
        );
      }
    );

    /* =========================================================
      DÉMARRAGE
    ========================================================= */

    masquer(
      noteSimulation
    );

    masquerWarningOrientation();

    masquer(
      validationZone2
    );

    masquer(
      zoneValidee2
    );

    masquer(
      ajoutZone2
    );

    masquer(
      carteVisuelZone2
    );

    masquer(
      importVisuelZone2
    );

    masquer(
      calqueSelection2
    );

    poignees2.forEach(
      masquer
    );

    mettreAJourInterface();


/*
 * VISUALISEUR 2 — MODÈLE SHOPIFY
 * Le visuel provient de la fiche produit.
 * Aucun fichier de production ni jeton privé nécessaire.
 */
async function chargerModeleShopify() {
  const conteneur = document.getElementById("avVisualiseurIntegre");
  const urlModele = conteneur?.dataset.avModeleImage;

  if (!urlModele) {
    console.warn("[Visualiseur 2] Image produit Shopify absente.");
    return;
  }

  try {
    await chargerImage(urlModele);

    fichierVisuelAdhesif = {
      source: "shopify",
      nom: "Modèle de la fiche produit"
    };

    urlVisuelAdhesif = urlModele;
    visuelPrincipalDepuisConfigurateur = true;

    masquerImportVisuelPrincipal();
    invaliderControlesOrientation();

    if (existe(apercuAdhesif)) {
      apercuAdhesif.src = urlModele;
      afficher(apercuAdhesifBloc, "flex");
    }

    mettreAJourInterface();

    console.log("[Visualiseur 2] Modèle Shopify chargé.");
  } catch (erreur) {
    console.error("[Visualiseur 2] Chargement du modèle :", erreur);
  }
}

chargerModeleShopify();
